import Alpine from "alpinejs";
import request from 'oc-request';

Alpine.data('favorites', (id) => ({
    id: id,



}));

Alpine.store('favorites', {
    favorites: [],

    init() {
         this.getFavorites().then(favorites => {
             this.favorites = Array.from(favorites);
             //console.log(this.favorites);
         });


    },

    async getFavorites() {
        return await new Promise((resolve, reject) => {
            request.sendData('Favorites::onGetFavorites', {
                success(res) {
                    resolve(res.favorites);
                },
                error (res) {
                    reject(res);
                }
            });
        });
    },

    toggle(id) {
        request.sendData('Favorites::onToggle', {

            data: {
                id: id
            },

            update: {

            },

            success(res) {
                this.favorites = res.favorites;
            }
        });
    }
});
